"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormalAttributeValues = exports.getFormalAttributeNames = void 0;
const predicate_language_1 = require("@groupby/predicate-language");
const getFormalAttributeNames = (client, ids) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const formalAttributeNames = yield client.formalAttributeNames.getMany({
            page: { limit: ids.length },
            filter: new predicate_language_1.PredicateBuilder((0, predicate_language_1.where)((0, predicate_language_1.f) `id`, '@<', ids.map((id) => (0, predicate_language_1.uuid)(id)))),
        });
        return formalAttributeNames;
    }
    catch (e) {
        console.error(e);
        return [];
    }
});
exports.getFormalAttributeNames = getFormalAttributeNames;
const getFormalAttributeValues = (client, ids) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const formalAttributeValues = yield client.formalAttributeValues.getMany({
            page: { limit: ids.length },
            filter: new predicate_language_1.PredicateBuilder((0, predicate_language_1.where)((0, predicate_language_1.f) `id`, '@<', ids.map((id) => (0, predicate_language_1.uuid)(id)))),
        });
        return formalAttributeValues;
    }
    catch (e) {
        console.error(e);
        return [];
    }
});
exports.getFormalAttributeValues = getFormalAttributeValues;
